import React from 'react';
import milaCircle from 'assets/images/mila-circle.png';
import bigsneezeCircle from 'assets/images/bigsneeze-circle.png';
import crittercuddlerCircle from 'assets/images/crittercuddler-circle.png';
import basicbreatherCircle from 'assets/images/basicbreather-circle.png';
import rookieparentsCircle from 'assets/images/rookieparents-circle.png';
import homewreckerCircle from 'assets/images/homewrecker-circle.png';
import mamatobeCircle from 'assets/images/mamatobe-circle.png';
import overreactorCircle from 'assets/images/overreactor-circle.png';
import loadable from '@loadable/component';
import { FILTER_NAMES, FILTER_TYPES } from '../../../shared/enums';

const LazyImg = loadable(() => import('../common/LazyImg'));

/**
 * @param type
 * @param author
 * @param text
 * @param isVisible
 * @returns {JSX.Element}
 * @constructor
 */
const ReviewCard = ({
  type, author, text, isVisible,
}) => {
  const icons = Object.freeze({
    [FILTER_TYPES.BB]: basicbreatherCircle,
    [FILTER_TYPES.BS]: bigsneezeCircle,
    [FILTER_TYPES.RP]: rookieparentsCircle,
    [FILTER_TYPES.CC]: crittercuddlerCircle,
    [FILTER_TYPES.HW]: homewreckerCircle,
    [FILTER_TYPES.MB]: mamatobeCircle,
    [FILTER_TYPES.OR]: overreactorCircle,
  });

  const variant = Object.keys(FILTER_TYPES).find(key => FILTER_TYPES[key] === type);

  return (
    <div className={`review-card__item grid-item ${isVisible} ${type}`}>
      <article className='review-block__item-inner'>
        <span className='review-block__item-bg' />
        <header className='review-block__header'>
          <figure className='review-block__profile-image'>
            <picture>
              <LazyImg src={icons[type] || milaCircle} alt={variant ? `${FILTER_NAMES[variant]}` : 'Fellow Air Breather'} />
            </picture>
          </figure>
          <div className='review-block__title-group'>
            <h2 className='review-block__title'>{author}</h2>
            <h3 className='review-block__subtitle'>{variant ? `A ${FILTER_NAMES[variant]}` : 'Fellow Air Breather'}</h3>
          </div>
        </header>
        <div className='review-block__content'>
          {text.search('\n') !== -1 ? text.split('\n').filter(line => line.length).map(line => <p>{line}</p>) : <p>{text}</p>}
        </div>
        <div className='review-block__share'>
          <a href='/referral' className='btn btn--share'>
            <svg className='icon icon-paper-plane'>
              <use xlinkHref='#icon-paper-plane' />
            </svg>
            Share love
          </a>
        </div>
      </article>
    </div>
  );
};

export default ReviewCard;
